const APP_LINK_ORIGIN = "https://cardpartner.net";
const CONFIRM_EMAIL_PATH = "/confirm-email";

/** Converts a verified public Android App Link into a safe in-app route. */
export const getNativeAppLinkTarget = (rawUrl: string): string | null => {
  try {
    const url = new URL(rawUrl);
    if (url.origin !== APP_LINK_ORIGIN || url.pathname !== CONFIRM_EMAIL_PATH) return null;
    return `${url.pathname}${url.search}${url.hash}`;
  } catch {
    return null;
  }
};
